<div class="count">
  <div class="newDeck">
    <h2>Criar Novo Deck</h2>

    <input type="text" placeholder="Nome do Deck" [(ngModel)]="deckName" />

    <!-- Select dinâmico populado pela API -->
    <select name="folder" [(ngModel)]="selectedFolderId">
      <option value="">Selecione uma Pasta</option>
      <!-- Itera sobre as pastas vindas do C# -->
      @for (folder of folders; track folder.idPasta) {
        <!-- O valor salvo será o ID, mas o utilizador vê o nome -->
        <option [value]="folder.idPasta">{{ folder.nome }}</option>
      }
    </select>

    <h3>Flashcards</h3>

    <div class="flashcards">
      @for (card of cards; track $index) {
        <div class="card-form">
          <textarea maxlength="255" placeholder="Pergunta" [(ngModel)]="card.question"></textarea>
          <textarea maxlength="255" placeholder="Resposta" [(ngModel)]="card.answer"></textarea>
          
          <!-- Não mostrar botão remover se só houver 1 cartão -->
          @if (cards.length > 1) {
            <button (click)="removeCard($index)"><ion-icon name="close"></ion-icon></button>
          }
        </div>
      }
    </div>

    <div class="buttons">
      <div class="">
        <button (click)="addCard()">Adicionar Card</button>
        <button class="save" (click)="save()">Salvar Deck</button>
      </div>
    </div>
  </div>
</div>